<div class="container">
  <div class="row mt-5"></div>

  <div class="row mt-5">
    <div class="col-12">
      <div class="header-text">Find a Provider</div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <div class="sub-text">Use the search below to find providers for your additional benefits.</div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <div class="alert alert-info mb-3" *ngIf="!isConfigReady">
        <div class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Loading provider search...
        </div>
      </div>

      <div *ngIf="isConfigReady">
        <wf-smart-search [config]="searchConfig"></wf-smart-search>
      </div>
    </div>
  </div>

  <div class="row mt-5"></div>
</div>
